import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import VendorTable from '../components/lexis/VendorTable'

export default function LexisVendors() {
    const navigate = useNavigate()
    const [vendors, setVendors] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [form, setForm] = useState({ name: '', country: '', website: '', contact_name: '', contact_email: '', contact_phone: '', relationship: 'known_vendor', notes: '' })
    const [loading, setLoading] = useState(true)

    useEffect(() => { load() }, [])
    const load = () => fetch('/api/lexis/vendors').then(r => r.json()).then(d => { setVendors(d.vendors || []); setLoading(false) })

    const submit = async (e) => {
        e.preventDefault()
        await fetch('/api/lexis/vendors', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) })
        setShowForm(false)
        setForm({ name: '', country: '', website: '', contact_name: '', contact_email: '', contact_phone: '', relationship: 'known_vendor', notes: '' })
        load()
    }

    const handleVendorClick = (v) => navigate(`/lexis?vendor=${v.id}`)

    if (loading) return <div style={{ padding: '40px', color: '#64748b' }}>Loading...</div>

    return (
        <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <div>
                    <h2 style={{ margin: 0, color: '#f1f5f9' }}>🏢 Vendor Directory</h2>
                    <p style={{ color: '#64748b', margin: '4px 0 0', fontSize: '13px' }}>Danh Mục Nhà Cung Cấp</p>
                </div>
                <button onClick={() => setShowForm(true)} style={{
                    padding: '10px 20px', background: 'rgba(212,175,55,0.15)', border: '1px solid rgba(212,175,55,0.3)',
                    borderRadius: '8px', color: '#d4af37', cursor: 'pointer', fontSize: '13px', fontWeight: 600,
                }}>+ Add Vendor</button>
            </div>

            {showForm && (
                <div style={{
                    position: 'fixed', top: 0, right: 0, width: '400px', height: '100vh',
                    background: '#0f172a', borderLeft: '1px solid rgba(148,163,184,0.1)',
                    padding: '24px', overflowY: 'auto', zIndex: 100,
                }}>
                    <h3 style={{ color: '#d4af37', marginTop: 0 }}>Add Vendor</h3>
                    <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {['name', 'country', 'website', 'contact_name', 'contact_email', 'contact_phone'].map(f => (
                            <input key={f} placeholder={f.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase())} value={form[f]}
                                onChange={e => setForm({ ...form, [f]: e.target.value })} required={['name'].includes(f)}
                                style={{ padding: '10px', background: 'rgba(30,41,59,0.8)', border: '1px solid rgba(148,163,184,0.2)', borderRadius: '8px', color: '#f1f5f9' }} />
                        ))}
                        <select value={form.relationship} onChange={e => setForm({ ...form, relationship: e.target.value })}
                            style={{ padding: '10px', background: 'rgba(30,41,59,0.8)', border: '1px solid rgba(148,163,184,0.2)', borderRadius: '8px', color: '#f1f5f9' }}>
                            <option value="known_vendor">Known Vendor</option>
                            <option value="authorized_reseller">Authorized Reseller</option>
                            <option value="distributor">Distributor</option>
                            <option value="partner">Partner</option>
                        </select>
                        <textarea placeholder="Notes" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })}
                            rows={3} style={{ padding: '10px', background: 'rgba(30,41,59,0.8)', border: '1px solid rgba(148,163,184,0.2)', borderRadius: '8px', color: '#f1f5f9' }} />
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <button type="submit" style={{ flex: 1, padding: '10px', background: '#d4af37', border: 'none', borderRadius: '8px', color: '#0f172a', fontWeight: 600, cursor: 'pointer' }}>Save</button>
                            <button type="button" onClick={() => setShowForm(false)} style={{ flex: 1, padding: '10px', background: 'rgba(30,41,59,0.8)', border: '1px solid rgba(148,163,184,0.2)', borderRadius: '8px', color: '#94a3b8', cursor: 'pointer' }}>Cancel</button>
                        </div>
                    </form>
                </div>
            )}

            <VendorTable vendors={vendors} onRowClick={handleVendorClick} />
        </div>
    )
}